import { BaseService } from "./base-service";

export class CommonApi {
   async getLmsLinks() {
      const path = `/api/v1/home/lms-links`;
      let response = await BaseService.AsyncGet(path);
      return response;
   }

   async getVersion() {
      const path = `/api/v1/home/version`;
      let response = await BaseService.AsyncGet(path);
      return response;
   }

   async saveEventErrorLog(eventType: string, message: string, failureReason: string, authoringSystem: string, authoringSystemForeignKey: string) {
      const path = `/api/v1/home/event-error-log`;
      let data = {
         eventType: eventType,
         message: message,
         failureReason: failureReason,
         authoringSystem: authoringSystem,
         authoringSystemForeignKey: authoringSystemForeignKey
      };
      return await BaseService.AsyncPost(path, data);
   }
}
